import * as React from "react";
import { Modal, Button } from "react-bootstrap";

import I18n from "lib/I18n";

interface HelpButtonProps {
  children?: React.ReactNode;
}

export function HelpButton(props: HelpButtonProps) {
  const { children } = props;
  const [show, setShow] = React.useState(false);
  const closeDialog = () => setShow(false);
  const openDialog = () => setShow(true);

  return (
    <span style={{ marginLeft: 5, display: "inline-block" }}>
      <Button variant="info" onClick={openDialog}>
        {I18n.t("event_master_editor.action.help")}
      </Button>
      <Modal size="lg" onHide={closeDialog} show={show}>
        <Modal.Header closeButton>
          <Modal.Title>{I18n.t("event_master_editor.action.help")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </span>
  );
}
